export class ScreenUtil {
	static escapeHtml(text: string | undefined) {
		if (!text) return ''
		return text
	}

	static provideDownload(
		content: any,
		fileName: string,
		action: 'open' | 'download',
		mimeType?: 'text/plain; charset=utf8' | string,
	) {
		const link = document.createElement('a')
		const file = new File(
			[content],
			fileName,
			mimeType ? { type: mimeType } : undefined,
		)
		const url = URL.createObjectURL(file)

		switch (action) {
			case 'open':
				window.open(url, '_blank')
				break
			case 'download':
				link.setAttribute('href', url)
				link.setAttribute('download', fileName)
				link.click()
				break
		}

		setTimeout(() => URL.revokeObjectURL(url), 10_000)
	}
}
